const paddings = {
    l: { vertical: 16, horizontal: 20 },
    m: { vertical: 12, horizontal: 12 },
    s: { vertical: 10, horizontal: 12 },
};

const innerRectHeight = 16;

interface CreateSVGElementOptions {
    height: number;
    width: number;
    children: string;
}

function createSVGElement({ height, width, children }: CreateSVGElementOptions) {
    return `<svg xmlns="http://www.w3.org/2000/svg" height="${height}" width="${width}">${children}</svg>`;
}

interface CreateSVGRectElementOptions {
    x: number;
    rx?: number;
    y: number;
    height: number;
    width: number;
    fill: string;
}

function createSVGRectElement({ x, rx = 0, y, height, width, fill }: CreateSVGRectElementOptions) {
    return `<rect x="${x}" y="${y}" height="${height}" width="${width}" fill="${fill}" rx="${rx}"></rect>`;
}

export const defaultColors = {
    background: '#fff',
    skeleton: '#b0bdd633',
    border: '#eff2f7',
};

/**
 * Генерация svg строки (аналогичной скелетону) грида для дальнейшей установки в качесте бекграунда для body грида.
 * Это необходимо в случае, когда происходит быстрый скролл грида и строки еще не успевают отрисоваться,
 * чтобы пользователь видел не белый экран, а данный бекграунд, по внешнему виду совпадающий со скелетоном грида.
 *
 * @param options.height Высота строки.
 * @param options.columns Набор колонок, содержащих ширину и наличие правого бордера.
 * @param options.colors Палитра цветов
 * @param options.cellSize Размер ячейки
 * @returns SVG строка грида, аналогичная скелетону.
 */
export function createSVGBackgroundRow({
    height,
    columns,
    colors = defaultColors,
    cellSize,
}: {
    height: number;
    columns: Array<{
        width: number;
        hasDelimiter?: boolean;
    }>;
    cellSize: 's' | 'm' | 'l';
    colors?: typeof defaultColors;
}) {
    const width = columns.reduce((acc, { width }) => acc + width, 0);
    const background = createSVGRectElement({
        x: 0,
        y: 0,
        height,
        width,
        fill: colors.background,
    });

    let offset = 0;
    const children = columns
        .reduce(
            (acc, { width, hasDelimiter }) => {
                acc.push(
                    /** skeleton */
                    createSVGRectElement({
                        x: offset + paddings[cellSize].horizontal,
                        rx: 4,
                        y: paddings[cellSize].vertical,
                        height: innerRectHeight,
                        width: width - 2 * paddings[cellSize].horizontal - (hasDelimiter ? 1 : 0),
                        fill: colors.skeleton,
                    }),

                    /** bottom border */
                    createSVGRectElement({
                        x: offset,
                        y: height - 1,
                        height: 1,
                        width,
                        fill: colors.border,
                    })
                );

                if (hasDelimiter) {
                    /** right border */
                    acc.push(
                        createSVGRectElement({
                            x: width + offset - 1,
                            y: 0,
                            height,
                            width: 1,
                            fill: colors.border,
                        })
                    );
                }

                offset += Number(width);

                return acc;
            },
            [background]
        )
        .join('\n');

    return createSVGElement({ height, width, children });
}
